/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { schemeSummarySchema } from './schemeSummarySchema';

export const resourceWithCurrentSchemesSchema = z.object({
  active: z.boolean(),
  createdAt: z.iso.datetime(),
  createdBy: z.string(),
  get currentSchemes() {
    return z.array(schemeSummarySchema);
  },
  employmentType: z.enum(['EMPLOYEE', 'CONTRACTOR', 'PARTNER', 'ON_DEMAND']),
  id: z.int(),
  name: z.string(),
  organizationId: z.string(),
  status: z.enum(['ACTIVE', 'DEACTIVATED']),
  type: z.enum(['RESOURCE', 'PLACEHOLDER']),
  updatedAt: z.iso.datetime(),
  updatedBy: z.string(),
  workforceCategory: z.enum(['EMPLOYEE', 'CONTRACTOR', 'VENDOR', 'FREELANCER']),
});
